import React, { useEffect } from "react";
import { BrowserRouter } from "react-router-dom";
import { useSelector } from "react-redux";
import { State } from "./store";
import FrameContainer from "./components/iFrameContainer";
import useBasketManager from "./components/SaleMovie/CinemaHall/hooks/useBasketManager";
import HandlerModalByUrl from "./components/HandlerModalByUrl";
import ShopNotWorking from "../features/Alerts/ShopNotWorking";
import HorizontalView from "./components/iFrameContainer/horizontalScreen";
import useFacility from "../utils/hooks/useFacility";
import Smartsupp from "./components/Smartsupp";
import useClearStorageAndCache from "../utils/hooks/useClearStorageAndCache";
import useMyAccount from "./components/MyAccount/hooks/useMyAccount";
import useSuccessRedirection from "../utils/hooks/useSuccessRedirection";

const MainApp: React.FC = () => {
  const saleConfiguration = useSelector((state: State) => state.config.configuration);
  const { getBasket } = useBasketManager();
  const facilityIds = useFacility();
  useMyAccount();

  useSuccessRedirection();

  useEffect(() => {
    setTimeout(() => {
      getBasket();

    }, 200);
  }, [facilityIds]);

  useEffect(() => {
    const localStorageLng = localStorage.getItem("i18nextLng");
    if (!localStorageLng) {
      localStorage.setItem("i18nextLng", "PL");
    }
  }, []);

  useClearStorageAndCache();

  return (
    <BrowserRouter>
      <HandlerModalByUrl />
      {saleConfiguration.chatOnline && <Smartsupp />}

      {saleConfiguration.saleActive ? (
        <div className="flex-center-center">
          <ShopNotWorking title={saleConfiguration.saleInActiveTitle} message={saleConfiguration.saleInActiveMessage} />
        </div>
      ) : (
        <div>
          <React.Fragment>
            {saleConfiguration.widgetActive ? (
              <div>
                <FrameContainer />
              </div>
            ) : (
              <div>
                <HorizontalView />
              </div>
            )}
          </React.Fragment>
        </div>
      )}
      {/* <AddToHomeScreen /> */}
    </BrowserRouter>
  );
};

export default MainApp;
